import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/subject/subjectClasses/subjectClassListContainer';
import { actions } from '../../../redux/subject/subjectClasses';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
